<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>Create wine</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-4">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="wine.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100" autofocus/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete v-model="wine.type" outlined dense label="Type"
                                :items="[{text:'Containing more than 7%',value:'WineHigh'},
                                        {text:'Containing more than 1.2%, but not more than 7%',value:'WineMedium'},
                                        {text:'Containing not more than 1.2%',value:'WineWeak'}]" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'WineQuickCreate',
	props: {
    value: {type:Boolean,required:true}
  },
  data() {
    return {
      valid: true,
      show: false,
      wine: {name:'',type:'WineHigh'},
      busy: false
    }
  },
  watch: {
    value() {
      this.wine.name = '';
      this.wine.type = 'WineHigh';
      this.show = this.value;
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation WineQuickCreate($input: WineInput!) {
                                            wineCreate(input:$input) {id,name}
                                          }`,
                                          {input:this.wine});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.wineCreate);
      }
    }
  }
}
</script>
